import { render, staticRenderFns } from "./FITB.vue?vue&type=template&id=2ae8fc49&"
import script from "./FITB.vue?vue&type=script&lang=js&"
export * from "./FITB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports